import React from 'react';
import {
  Box,
} from '@mui/material';
import { useWarbandStore } from '../../stores/warbandStore';
import { EmptyStateCard } from '../shared/EmptyStateCard';
import { CategoryFilteredSpellList } from '../shared/CategoryFilteredSpellList';
import { createIceSurface } from '../../theme/surfaces';


export const ManageWizardsAndSpellsTab: React.FC = () => {
  const spellcastersAndSpells = useWarbandStore((s) => s.spellcastersAndSpells);

  const spells = spellcastersAndSpells?.warbandSpells || [];

  const iceSurface = createIceSurface(100, { icicles: true, card: true });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={iceSurface} p={1.5}>
        {spells.length > 0 ? (
          <CategoryFilteredSpellList exclude={true} categoryIds={[]} label="All Spells" allowDelete allowImprove />
        ) : (
          <EmptyStateCard message="Your spellcasters know no spells." />
        )}
      </Box>
    </Box>
  );
};
